import {
    REQUEST_ARRIVAL_PROBLEM,
    REQUEST_ARRIVAL_PROBLEM_FAILURE,
    REQUEST_ARRIVAL_PROBLEM_SUCCESS
} from "../../../constant/transaction/ShipmentConstant";

const initialState = {
    arrivalProblem: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const arrivalProblemReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_ARRIVAL_PROBLEM:
            return {
                ...state,
                arrivalProblem: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_ARRIVAL_PROBLEM_SUCCESS:
            return {
                ...state,
                arrivalProblem: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_ARRIVAL_PROBLEM_FAILURE:
            return {
                ...state,
                arrivalProblem: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
